import * as dateFNSlocales from 'date-fns/locale';

export const availableLocaleConfigs: { [key: string]: any } = {
  'cs-CZ': dateFNSlocales.cs,
  'da-DK': dateFNSlocales.da,
  'de-AT': dateFNSlocales.de,
  'de-BE': dateFNSlocales.de,
  'de-CH': dateFNSlocales.de,
  'de-DE': dateFNSlocales.de,
  'de-LU': dateFNSlocales.de,
  'el-GR': dateFNSlocales.el,
  'en-CA': dateFNSlocales.enCA,
  'en-GB': dateFNSlocales.enGB,
  'en-IE': dateFNSlocales.enGB,
  'en-US': dateFNSlocales.enUS,
  'es-ES': dateFNSlocales.es,
  'fi-FI': dateFNSlocales.fi,
  'fi-SE': dateFNSlocales.fi,
  'fr-BE': dateFNSlocales.fr,
  'fr-CA': dateFNSlocales.fr,
  'fr-CH': dateFNSlocales.fr,
  'fr-FR': dateFNSlocales.fr,
  'fr-LU': dateFNSlocales.fr,
  'hr-HR': dateFNSlocales.hr,
  'it-CH': dateFNSlocales.it,
  'it-IT': dateFNSlocales.it,
  'ja-JP': dateFNSlocales.ja,
  'ko-KR': dateFNSlocales.ko,
  'nb-NO': dateFNSlocales.nb,
  'nl-BE': dateFNSlocales.nl,
  'nl-NL': dateFNSlocales.nl,
  'nn-NO': dateFNSlocales.nb,
  'no-NO': dateFNSlocales.nb,
  'pl-PL': dateFNSlocales.pl,
  'pt-PT': dateFNSlocales.pt,
  'ru-RU': dateFNSlocales.ru,
  'sk-SK': dateFNSlocales.sk,
  'sl-SI': dateFNSlocales.sl,
  'sv-FI': dateFNSlocales.sv,
  'sv-SE': dateFNSlocales.sv,
  'zh-CN': dateFNSlocales.zhCN,
  'lv-LV': dateFNSlocales.lv,
  'lt-LT': dateFNSlocales.lt,
  'et-EE': dateFNSlocales.et,
  'is-IS': dateFNSlocales.is,
};
